import { Injectable } from '@angular/core';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';
export interface ViewportSize {
  width: number;
  height: number;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private userAgent: string = navigator.userAgent.toLowerCase();

  constructor() {}

  /**
   * Determines the device type based on user agent and viewport width.
   * - Mobile: width < 768px or specific mobile UA
   * - Tablet: width 768px - 1024px or specific tablet UA
   * - Desktop: width > 1024px
   */
  getDeviceType(): DeviceType {
    const width = window.innerWidth;

    // Check user agent for mobile-specific patterns
    const isMobileUA = /iphone|android|blackberry|windows phone/i.test(this.userAgent);
    const isTabletUA = /ipad|android(?!.*mobile)|tablet/i.test(this.userAgent);

    if (isMobileUA && width < 768) {
      return 'mobile';
    } else if (isTabletUA || (width >= 768 && width <= 1024)) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }

  /**
   * Checks if the device is an Apple device (iPhone, iPad).
   */
  isAppleDevice(): boolean {
    return /iphone|ipad/i.test(this.userAgent);
  }

  /**
   * Returns the current viewport width and height in pixels.
   */
  getDeviceViewport(): ViewportSize {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
}